<ng-container *ngIf="!phxLoading; else loading">
  <ng-content></ng-content>
</ng-container>
<ng-template #loading>
  <phx-spinner phxSize="small"></phx-spinner>
</ng-template>
